import { render } from "./RequestItem.vue?vue&type=template&id=6a8e355e&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=6a8e355e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a8e355e"

export default script